import { useTranslation } from 'react-i18next'

const NoOpinionsDadStart = (props) => {
  const { t } = useTranslation()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="noopinionsdad-start-title"
      {...props}
    >
      <title id="noopinionsdad-start-title">{t('antagonists:noOpinionsDad:components:start')}</title>
      <defs>
        <clipPath id="noopinionsdad-a">
          <path
            d="M1494.11 325.88s15.67 26.2 48.6 21.34c21.18-3.13 19.25-12.96 19.25-12.96s40.72 13.29 53.57 25.04c12.85 11.75 21.48 37.32 33.59 62.65 12.11 25.33 19.96 60.75 4.54 68.1-15.42 7.34-45.52 7.23-45.52 7.23s1.64 42.08 4.17 66.62c2.72 26.33 5.25 39.39 5.25 39.39s-20.6 12.7-83.74 10.5c-63.14-2.2-83.83-8.03-83.83-8.03s-4.03-15.21-1.82-31.36c2.2-16.15 7.11-68.77 7.11-68.77s-17.71 5.12-26.8-61.67c-5.54-40.7-12.1-67.91 4.41-88.1 10.71-13.1 34.71-16.07 43.32-20.92 11.62-6.55 17.92-9.04 17.92-9.04Z"
            style={{
              fill: '#009e8b',
            }}
          />
        </clipPath>
      </defs>
      <path
        d="M1476.03 940.42s5.33 15.6 3.42 23.59c-1.9 7.99-11.41 20.54-12.17 25.87-.76 5.33-.38 13.7-.38 13.7s16.36 2.28 25.87 1.9c9.51-.38 23.21-1.14 23.21-1.14s-1.14-17.12-1.14-23.21 1.14-10.65 0-16.74c-1.14-6.09-3.04-24.35-3.04-24.35l-35.76.38Zm102.58-3.99s1.63 7.22.36 13.72c-1.26 6.5-4.69 18.78-5.06 26-.36 7.22-.54 11.38-.54 11.38l8.85 4.51.36 9.39s16.79 2.89 27.45 1.81c10.65-1.08 21.67-2.71 21.67-2.71s.36-8.49-4.69-15.35c-5.06-6.86-10.65-13.18-13.18-18.06-2.53-4.88-5.78-27.45-5.78-27.45l-29.43-3.25Z"
        style={{
          fill: '#4b6c52',
        }}
      />
      <path
        d="M1458.12 550.1s-8.83 62.7-9.71 94.49c-.88 31.79 7.06 121.87 7.06 137.77 0 15.9-2.65 71.97 2.21 103.32 4.86 31.35 16.69 75.33 16.69 75.33l42.75-1.58s-2.48-71.54-1.16-100.68-.44-64.91 1.32-88.75c1.77-23.84 17.03-95.72 17.03-95.72s16.09 73.21 22.71 92.63c6.62 19.43 7.51 77.27 10.6 112.16 3.09 34.88 4.93 78.65 4.93 78.65l40.55-1.38s14.13-53.87 14.57-98.47c.44-44.6-6.18-106.42-6.18-136.44 0-30.03 4.42-73.74-3.53-113.92-7.95-40.18-19.87-64.03-19.87-64.03l-139.97 6.62Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1498.67 289.46s.7 29.38-3.12 35.11c-3.82 5.73-35.96 20.75-35.96 20.75l5.99 28.15 124.74-.32-6.59-26.1s-25.44-11.7-27.67-19.02c-2.23-7.32-.12-39.21-.12-39.21l-57.28.64Z"
        style={{
          fill: '#d18850',
        }}
      />
      <path
        d="M1507.38 198.68c-11.09 1.67-36.28 17.42-29.69 41.94 1.17 4.35 7.45 10.72 9.96 21.16 1.64 6.8 8.4 34.44 8.4 34.44l68.32-22.65s-.35-4.9 2.16-12.64c2.51-7.74 9.84-14.66 7.54-21.98s-20.6-33.49-30.2-36.09c-20.08-5.44-27.04 2.29-31.78.9-5.02-1.46-1.18-5.6-4.7-5.07Z"
        style={{
          fill: '#c0c2c4',
        }}
      />
      <path
        d="M1525.87 226.83c-9.4.77-15.26-2.41-21.19.5-7.97 3.9-6.54 9.97-8.04 15.62-3.13 11.78-5.98 14.88-4.14 25.18 1.84 10.31 8.47 29.95 13.81 40.07 5.34 10.12 10.67 8.28 17.3 8.83 6.63.55 17.12.37 21.53-6.81s13.43-22.08 14.91-32.39c1.47-10.31.55-27.25-3.7-37.94-2.13-5.36-2.04-10.01-10.69-14.08-6.46-3.04-14.76.61-19.8 1.02Z"
        style={{
          fill: '#d18850',
        }}
      />
      <path
        d="M1494.15 269.82s-6.77-2.93-11.19-.36c-4.42 2.58-.74 13.43.92 18.59 1.66 5.15 3.5 6.07 6.07 5.71 2.58-.37 5.52-2.21 5.52-2.21l-1.33-21.73Zm68.02-2.51s3.68-3.86 8.1-1.29c4.42 2.58.74 13.43-.92 18.59-1.66 5.15-3.5 6.07-6.07 5.71-2.58-.37-5.52-2.21-5.52-2.21l4.42-20.8Z"
        style={{
          fill: '#d18850',
        }}
      />
      <path
        d="M1530.31 275.26c3.18 0 11.35 5.9 14.94 9.33 4.07 3.88 8.23 1.25 13.14-10.24 3.1-7.27 1.22-23.88 1.22-23.88l7.46-.88s-3.62 8.08-3.62 12.47-1.65 9.98-2.38 14.49 3.23 13.92 1.4 21.11-10.64 16.23-15.15 22.32-12.8 7.28-19.14 7.03c-6.34-.24-15.79 1.24-21.76-7.41-5.97-8.65-13.43-17.87-14.28-25.18-.85-7.31.07-16.84-1.48-26.9-.93-6.03-.02-17.17.23-17.53.24-.37 4.19-1.43 4.19-1.43s-1.98 9.26-1.73 13.28c.24 4.02.54 7.54 1.64 13.51 1.1 5.97 8.28 14.11 10.82 10.59 2.94-4.07 11.52-8.72 14.33-9.77 5.24-1.95 4.26 1.35 6.34 1.22 1.95-.12 1.65-2.13 3.84-2.13Zm-3.47 3.47c-2.55-.2-10.55 3.37-13.56 6.85-3.96 4.56-6.33 14.62-2 16.75 8.58 4.24 10.06-3.71 15.06-3.46 5 .24 7.26 7.33 13.72 2.63 6.15-4.47 1.77-13.33-.84-16.21-2.18-2.41-8.77-6.26-12.38-6.55Z"
        style={{
          fill: '#c0c2c4',
        }}
      />
      <path
        d="M1522.01 280.38c2.27-.69 3.07.7 3.86.6.79-.1 1.48-1.58 4.43-.59 3.85 1.28 9.56 6.4 9.06 8.18-.49 1.77-8.05 7.4-13.08 7.6-5.02.2-12.28-6.55-12.43-8.26-.2-2.27 5.89-6.83 8.15-7.52Zm-2.45 7.01c.21.55 3.18 1.97 6.27 2.04 3.15.07 6.83-1.19 6.93-1.78.1-.59-3.25-2.53-6.6-2.63-3.35-.1-6.9 1.58-6.6 2.37Z"
        style={{
          fill: '#f4a019',
        }}
      />
      <path
        d="M1510.79 253.45c-1.91.66-2.81 2.4-2.09 4.25.72 1.84 2.19 2.18 3.94 1.7 2.06-.57 2.8-2.19 2.25-4.16-.38-1.39-2.14-2.47-4.1-1.79Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        style={{
          fill: '#1c3628',
        }}
        d="m1504.06 256.22 12.54-2.82-1.33-4.76-11.76 5.43.55 2.15z"
      />
      <path
        d="M1515.16 249.21s-3.69-2.48-7.76-2.33c-4.07.16-9.33 3.71-9.33 3.71l-1.03-3.72s5.2-3.44 11.2-3.79c3.12-.19 8.33 1.51 8.33 1.51l-1.42 4.62Zm25.49 5.1c1.91.66 2.81 2.4 2.09 4.25s-2.19 2.18-3.94 1.7c-2.06-.57-2.8-2.19-2.25-4.16.38-1.39 2.14-2.47 4.1-1.79Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        style={{
          fill: '#1c3628',
        }}
        d="m1547.49 256.97-12.18-3.18.78-4.74 11.95 5.53-.55 2.39z"
      />
      <path
        d="M1536.22 250.21s3.21-3.08 7.24-3.62c4.04-.54 10.65 2.53 10.65 2.53l-.46-4.32s-5.71-2.49-11.68-1.82c-3.1.35-8.37 2.83-8.37 2.83l2.6 4.39Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1494.11 325.88s15.67 26.2 48.6 21.34c21.18-3.13 19.25-12.96 19.25-12.96s40.72 13.29 53.57 25.04c12.85 11.75 21.48 37.32 33.59 62.65 12.11 25.33 19.96 60.75 4.54 68.1-15.42 7.34-45.52 7.23-45.52 7.23s1.64 42.08 4.17 66.62c2.72 26.33 5.25 39.39 5.25 39.39s-20.6 12.7-83.74 10.5c-63.14-2.2-83.83-8.03-83.83-8.03s-4.03-15.21-1.82-31.36c2.2-16.15 7.11-68.77 7.11-68.77s-17.71 5.12-26.8-61.67c-5.54-40.7-12.1-67.91 4.41-88.1 10.71-13.1 34.71-16.07 43.32-20.92 11.62-6.55 17.92-9.04 17.92-9.04Z"
        style={{
          fill: '#009e8b',
        }}
      />
      <g
        style={{
          clipPath: 'url(#noopinionsdad-a)',
        }}
      >
        <path
          d="M1361.99 377.11s31-20.97 78.4-5.47c47.41 15.5 65.64 25.53 111.22 27.35 45.58 1.82 114.87-28.26 114.87-28.26l-2.73-103.02-322.73 6.38 20.97 103.02Z"
          style={{
            fill: '#62ac6d',
          }}
        />
        <path
          d="M1533.36 352.17c21.29.17 29.4-6.45 32.44-11.89 3.04-5.44 2.4-11.68 2.4-11.68l-80.18-14.72.32 9.28s5.81 28.69 45.02 29.01Z"
          style={{
            fill: '#e5352d',
          }}
        />
      </g>
      <path
        d="M1533.45 438.8c1.47 2.94 2.2 10.28 1.47 17.99-.73 7.71-3.99 10.67-3.99 10.67s-6.12-.9-13.43-1.16c-7.03-.24-15.5-2.87-20.28-4.89-9.54-4.04-8.72-18.33-8.72-18.33s6.75-2.89 12.99-1.42c6.24 1.47 9.57-.3 13.61-1.4 4.04-1.1 18.36-1.47 18.36-1.47Z"
        style={{
          fill: '#d18850',
        }}
      />
      <path
        d="M1515.76 439.25s-1.85 6.97-2.14 11.44c-.25 3.75 1.74 17.49 1.74 17.49l12.55 1.14s-.36-13.89-.74-19.68c-.38-5.79.59-11.85.59-11.85l-12 1.46Z"
        style={{
          fill: '#f4a019',
        }}
      />
      <path
        d="M1597.33 438.44s6.38-10.39 7.75-12.35c1.37-1.96 19.47-11.91 19.47-11.91s2.29 2.11 1.51 3.88c-.78 1.76-2.16 3.72-2.16 3.72l10.19-3.92s2.91 1.77 1.19 3.81c-1.93 2.3-3.32 4.33-3.32 4.33l6.64-.89s1.57 3.53-.39 5.49c-1.96 1.96-5.09 3.51-5.09 3.51s4.3.81 4.3 2.18-1.96 3.14-1.96 3.14-13.92-.39-22.74.78c-8.82 1.18-15.39-1.77-15.39-1.77Z"
        style={{
          fill: '#d18850',
        }}
      />
      <path
        d="M1521.65 440.64c-6.38-.1-10.05 4.42-10.21 9.62-.16 5.28 4.09 9.23 9.47 9 5.25-.22 9.3-4.65 9.51-9.45.2-4.62-2.89-9.08-8.77-9.17Z"
        style={{
          fill: '#f4a019',
        }}
      />
      <path
        d="M1521.55 442.4c-5.21-.06-8.21 3.62-8.37 7.87-.16 4.35 3.32 7.63 7.77 7.46 4.36-.17 7.71-3.85 7.86-7.83.14-3.81-2.43-7.44-7.25-7.5Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <path
        style={{
          fill: '#404b51',
        }}
        d="m1516.55 451.06 4.51-2.07 6.27 3.26-.35.59-5.89-3.03-4.27 1.86-.27-.61z"
      />
    </svg>
  )
}

export default NoOpinionsDadStart
